<div
	class="pos"
	[ngStyle]="reservation.styles"
	*ngFor="let reservation of reservations"
	(click)="select(reservation, reservations)"
>
	<i class="fas fa-anchor" *ngIf="reservation.istourRoomCode"></i>
	<i class="far fa-eye" *ngIf="!reservation.istourRoomCode && reservation.viewGuarantee === '1'"></i>
	<i class="fas fa-bezier-curve" *ngIf="reservation.combined === '1'"></i>
	<b>{{ reservation.businessCaseNumber }}</b>
	{{ reservation.roomTypeName }}
	<span *ngIf="reservation.countRoom > 1">1/{{ reservation.countRoom }}</span>
</div>
